import React, { useState, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import { makeStyles } from '@material-ui/core/styles'
import { TextField, IconButton, Dialog, DialogTitle } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  textField: {
    flex: '1 0 auto'
  },
  searchButton: {
    flex: '0 0 auto'
  },
  dialogTitle: {
    padding: '0.5rem 0.5rem'
  },
  dialogTitleLabel: {
    flex: '1 0 auto'
  },
  dialogCloseButton: {
    flex: '0 0 auto',
    padding: '0.25rem'
  }
}))

function SelectDialog (props) {
  const { objects, onClose, selectedValue, open, label } = props
  const classes = useStyles()

  const handleClose = () => {
    const filtered = objects.filter((obj) => obj.id === selectedValue)
    const text = filtered.length ? filtered[0].name : ''
    onClose(selectedValue, text)
  }

  const handleListItemClick = (value) => () => {
    const filtered = objects.filter((obj) => obj.id === value)
    const text = filtered.length ? filtered[0].name : ''
    onClose(value, text)
  }

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle id="simple-dialog-title" className={classes.dialogTitle}>
        <div className="d-flex align-items-center">
          <span className="ml-1">{label}選択</span>
          <IconButton type="button" aria-label="close" className={classes.dialogCloseButton}
            onClick={handleClose}>
            <ClearIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <div className="list-group m-1">
        {objects.map((obj, i) => {
          return (
            <button type="button" className="list-group-item list-group-item-action" key={obj.id}
              onClick={handleListItemClick(obj.id)} autoFocus={i === 0}>
              {obj.name}
            </button>
          )
        })}
      </div>
    </Dialog>
  )
}

SelectDialog.propTypes = {
  objects: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func,
  selectedValue: PropTypes.number,
  open: PropTypes.bool,
  label: PropTypes.string
}

export default function InteractiveDialogInput (props) {
  const { label, placeholder, name, postUrl, oldObject, readonly, errorMessage } = props
  const classes = useStyles()

  const [open, setOpen] = useState(false)
  const [nameQuery, setNameQuery] = useState(oldObject ? oldObject.name : '')
  const [objects, setObjects] = useState([])
  const [selectedValue, setSelectedValue] = useState(oldObject ? oldObject.id : null)
  const csrfRef = useRef($('meta[name="csrf-token"]'))

  function onSearchButtonClick () {
    $.ajax({
      url: postUrl,
      type: 'POST',
      data: {
        ...props.postData,
        _token: csrfRef.current.attr('content'),
        spname: nameQuery
      }
    }).done((data) => {
      setObjects(data.result)
      setOpen(true)
      csrfRef.current.attr('content', data['csrf-token'])
      $('input[name="_token"]').val(data['csrf-token'])
    }).fail((jqXHR, textStatus, errorThrown) => {
      console.error(errorThrown)
    })
  }

  function onClearButtonClick () {
    setNameQuery('')
    setSelectedValue(null)
  }

  function onDialogClose (value, name) {
    setOpen(false)
    setSelectedValue(value)
    setNameQuery(name)
  }

  return (
    <div className={classes.root}>
      <TextField
        variant="standard"
        value={nameQuery}
        onChange={(e) => {
          setNameQuery(e.target.value)
        }}
        label={label}
        placeholder={placeholder}
        className={classes.textField}
        error={errorMessage !== ''}
        helperText={errorMessage}
        required={true}
        disabled={readonly}
        InputProps={{
          readOnly: selectedValue > 0,
          onKeyDown: (e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              if (!selectedValue) {
                onSearchButtonClick()
              }
            }
          }
        }}
      />
      {!readonly && (
        <IconButton type="button" className={classes.searchButton} aria-label="search"
          onClick={selectedValue ? onClearButtonClick : onSearchButtonClick}>
          {selectedValue ? <ClearIcon /> : <SearchIcon />}
        </IconButton>
      )}
      <SelectDialog
        objects={objects}
        onClose={onDialogClose}
        selectedValue={selectedValue}
        open={open}
        label={label}
      />
      <input type="text" name={name} className="d-none" value={selectedValue || ''} readOnly />
    </div>
  )
}

InteractiveDialogInput.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  postUrl: PropTypes.string,
  postData: PropTypes.object,
  oldObject: PropTypes.object,
  readonly: PropTypes.bool,
  errorMessage: PropTypes.string
}

InteractiveDialogInput.defaultProps = {
  placeholder: '',
  postData: {},
  oldObject: null,
  readonly: false,
  errorMessage: ''
}

const elem = $('.interactive-dialog-input')
elem.each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる

  ReactDOM.render(<InteractiveDialogInput {...props}/>, el)

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
